import { useState } from 'react';
import { SlidersHorizontal } from 'lucide-react';
// import { Filter, SlidersHorizontal } from 'lucide-react';
import { AnchoredDropdownMenu } from './AnchoredDropdownMenu';
import { ProfessionalHeaderCalendarViewPill } from './ProfessionalHeaderCalendarViewPill';
import { cn } from '@/lib/utils';
// import { useProfessionalCalendar } from '@/context/ProfessionalCalendarContext';
import {
	professionalHeaderActionIconClass,
	professionalHeaderIconOnlyButtonClass,
} from './professionalHeaderConstants';

// const menuItemClass =
// 	'flex w-full items-center gap-2.5 px-3.5 py-3 text-left text-sm font-semibold text-stone-700 transition-colors hover:bg-stone-50 focus:outline-none';

const ProfessionalHeaderCalendarOptionsMenu = () => {
	const [open, setOpen] = useState(false);
	// const { toggleHistoryPanel, isHistoryPanelOpen } = useProfessionalCalendar();
	// const closeMenu = () => setOpen(false);

	return (
		<div className="min-[1050px]:hidden">
			<AnchoredDropdownMenu
				open={open}
				onOpenChange={setOpen}
				menuWidth={180}
				estimatedHeight={160}
				menuClassName="w-54 max-w-[calc(100vw-1rem)] overflow-x-hidden p-0 animate-in fade-in zoom-in-95 duration-100"
				trigger={({
					ref: setAnchorRef,
					isOpen: menuOpen,
					onTriggerClick,
				}) => (
					<button
						ref={setAnchorRef}
						type="button"
						onClick={onTriggerClick}
						className={cn(
							professionalHeaderIconOnlyButtonClass,
							menuOpen && 'bg-stone-100 hover:bg-stone-100',
						)}
						aria-label="Opções do calendário"
						aria-expanded={menuOpen}
						aria-haspopup="menu"
					>
						<SlidersHorizontal
							className={cn(
								professionalHeaderActionIconClass,
								'text-stone-700',
							)}
							strokeWidth={2}
						/>
					</button>
				)}
			>
				<div className="flex flex-col py-1">
					{/* Item de filtro oculto temporariamente
					<button
						type="button"
						onClick={() => {
							toggleHistoryPanel();
							closeMenu();
						}}
						className={cn(menuItemClass, isHistoryPanelOpen && 'bg-stone-50')}
						role="menuitem"
					>
						<Filter
							className={cn(
								'size-[18px] shrink-0 text-stone-500',
								isHistoryPanelOpen && 'fill-current',
							)}
							strokeWidth={2}
						/>
						Filtros
					</button>

					<div className="border-t border-stone-100 px-3.5 py-3">
					*/}
					<div className="px-3.5 py-3">
						<ProfessionalHeaderCalendarViewPill className="w-full" />
					</div>
				</div>
			</AnchoredDropdownMenu>
		</div>
	);
};

export { ProfessionalHeaderCalendarOptionsMenu };
